module.exports = __webpack_public_path__ + "img/portal-samp-register.a27596cd.jpg";